"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarFilter = exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Actions = __importStar(require("../calendar-actions"));
var theme_1 = require("../../theme");
var OuterContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  button {\n    margin: 2px;\n  }\n"], ["\n  button {\n    margin: 2px;\n  }\n"])));
var PeopleFilterList = styled_components_1.default.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  list-style-type: none;\n  display: grid;\n  max-width: 700px;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 2px;\n"], ["\n  list-style-type: none;\n  display: grid;\n  max-width: 700px;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 2px;\n"])));
var FilterButtonGroup = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var FilterButtonGroupsContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: 6px 24px;\n  flex-wrap: wrap-reverse;\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 6px 24px;\n  flex-wrap: wrap-reverse;\n"])));
exports.Button = styled_components_1.default.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 4px 8px;\n  border-radius: 3px;\n  color: ", ";\n  font-size: 1rem;\n  border: solid 2px ", ";\n  box-shadow: 0px 1px 2px ", ";\n\n  &:hover {\n    cursor: pointer;\n    box-shadow: 0px 2px 5px ", ";\n  }\n"], ["\n  background-color: ", ";\n  padding: 4px 8px;\n  border-radius: 3px;\n  color: ", ";\n  font-size: 1rem;\n  border: solid 2px ", ";\n  box-shadow: 0px 1px 2px ", ";\n\n  &:hover {\n    cursor: pointer;\n    box-shadow: 0px 2px 5px ", ";\n  }\n"])), function (props) { var _a; return (props.active ? (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors.divid : "transparent"); }, function (props) { return (props.active ? props.theme.colors.bodyInverted : props.theme.colors.body); }, function (props) { var _a; return (props.active ? "transparent" : (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors.divid); }, function (_a) {
    var theme = _a.theme;
    return theme.colors.dropShadow;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.dropShadowHighContrast;
});
var teams = {
    Custom: [
        "All SE",
        "Martin",
        "Max",
        "Josef D",
        "Johan Kå",
        "Findlay",
        "Leif",
        "Björn T",
        "Markus I",
        "Marcus N",
        "Zlatan",
        "Oskar",
        "Henrik",
        "Björn L",
        "Axel",
        "Rasmus S",
        "Victor",
        "Johan Kr",
        "Nebiyat",
        "Christer",
        "Fredrik",
        "Saga",
        "Filip",
        "Emil",
        "Albin"
    ],
    Product: [
        "All AL",
        "All DE",
        "All IT",
        "All SE",
        "Max",
        "Adam",
        "Tim",
        "Rasmus H",
        "Joakim",
        "Stefan",
        "Jonadri",
        "Serxho",
        "Josef G",
        "Ivan",
        "Christiane",
        "Anisa",
        "Endri",
        "Xhoana",
        "Kamila",
        "Auron",
        "Noemi",
    ],
    ProductDevelop: [
        "All AL",
        "All DE",
        "All IT",
        "All SE",
        "Max",
        "Adam",
        "Tim",
        "Rasmus H",
        "Joakim",
        "Stefan",
        "Jonadri",
        "Serxho",
        "Josef G",
        "Christiane",
    ],
    ProductCustomer: [
        "All AL",
        "All DE",
        "All IT",
        "All SE",
        "Ivan",
        "Anisa",
        "Endri",
        "Xhoana",
        "Kamila",
        "Auron",
        "Noemi",
    ],
    Munters: ["Martin", "Max", "Josef D", "Johan Kå", "Saga"],
    FläktGroup: ["Leif", "Björn T", "Markus I", "Filip"],
    Systemair: ["Zlatan", "Oskar", "Henrik", "Fredrik", "Emil", "Carl"],
    Nibe: ["Axel", "Rasmus S", "Findlay", "Victor"],
    Panasonic: ["Johan Kr", "Nebiyat", "Albin", "Zlatan"],
};
var bookingTypes = {
    Parking: ["Park. 43", "Park. 47"],
    Desks: [
        "Flexplats 1",
        "Flexplats 2",
        "Flexplats 3",
        "Flexplats 4",
        "Flexplats 5",
        "Flexplats 6",
        "Flexplats 7",
        "Flexplats 10",
        "Flexplats 11",
        "Flexplats 12",
        "Flexplats 13",
    ],
};
function CalendarFilter(_a) {
    var dispatch = _a.dispatch, filteredResources = _a.filteredResources, allResources = _a.allResources, showFilter = _a.showFilter, calendarId = _a.calendarId;
    var isChecked = function (resource) {
        return filteredResources === undefined ||
            filteredResources.some(function (filteredResource) { return filteredResource.id === resource.id; });
    };
    var isNameChecked = function (name) {
        return filteredResources === undefined || filteredResources.some(function (resource) { return resource.firstName === name; });
    };
    var filterGroupCollection = {
        divid: teams,
        support: undefined,
        booking: bookingTypes,
    }[calendarId];
    return (react_1.default.createElement(OuterContainer, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(FilterButtonGroupsContainer, null,
                    react_1.default.createElement(FilterButtonGroup, null,
                        react_1.default.createElement(exports.Button, { onClick: function () {
                                dispatch(Actions.toggleCalendarFilter());
                            }, active: showFilter, color: theme_1.calendarTheme.colors.secondary }, "Filter")),
                    react_1.default.createElement(FilterButtonGroup, null,
                        react_1.default.createElement(exports.Button, { onClick: function () {
                                dispatch(Actions.clearFilteredResources());
                            }, active: allResources.every(isChecked) }, "Show all"),
                        react_1.default.createElement(exports.Button, { onClick: function () {
                                dispatch(Actions.setFilteredResources([]));
                            }, active: (filteredResources === null || filteredResources === void 0 ? void 0 : filteredResources.length) === 0 }, "Hide all")),
                    filterGroupCollection && (react_1.default.createElement(FilterButtonGroup, null, Object.entries(filterGroupCollection).map(function (_a, index) {
                        var _b = __read(_a, 2), filterGroupName = _b[0], filterGroupResources = _b[1];
                        return (react_1.default.createElement(FilterGroupButton, { key: index, dispatch: dispatch, resources: allResources, filterGroupName: filterGroupName, filterGroupResources: filterGroupResources, active: filterGroupResources.every(isNameChecked) }));
                    })))))),
        showFilter && (react_1.default.createElement("div", null,
            react_1.default.createElement(PeopleFilterList, null, allResources.map(function (person) { return (react_1.default.createElement("li", { key: person.id },
                react_1.default.createElement("input", { readOnly: true, type: "checkbox", value: person.id, checked: isChecked(person), onClick: function () {
                        var isNowChecked = !isChecked(person);
                        var newFiltered = isNowChecked
                            ? (filteredResources || allResources).concat(person)
                            : (filteredResources || allResources).filter(function (checkedPerson) { return checkedPerson.id !== person.id; });
                        dispatch(Actions.setFilteredResources(newFiltered));
                    } }),
                " ",
                person.firstName)); }))))));
}
exports.CalendarFilter = CalendarFilter;
function FilterGroupButton(_a) {
    var dispatch = _a.dispatch, resources = _a.resources, filterGroupName = _a.filterGroupName, filterGroupResources = _a.filterGroupResources, active = _a.active;
    var teamColor = theme_1.calendarTheme.colors.filterGroups[filterGroupName !== null && filterGroupName !== void 0 ? filterGroupName : "default"];
    return (react_1.default.createElement(exports.Button, { color: teamColor, onClick: function () {
            var newFilteredResources = resources.filter(function (resource) { return filterGroupResources.includes(resource.firstName); });
            dispatch(Actions.setFilteredResources(newFilteredResources));
        }, active: active }, filterGroupName));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=calendar-filter.js.map